import { url, setTip, bi } from './gb'
import Login from './login'
import Scene from './scene'
import fullPage from './fullpage'
import Friend from './friend'
import Lottery from './lottery'

let isRoleBind = 0,
  userInfo = {},
  roleList = [],
  tempRoleList,
  tempServerList,
  sceneTarget = null

const sel_platform = $('#platform'),
  sel_server = $('#server'),
  sel_role = $('#role')
const Role = {
  api_getUserInfo: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.userInfo,
        dataType: 'jsonp'
      }).done(d => {
        if (d.success) {
          userInfo = d.data
          isRoleBind = 1
          Role.state_roleBinded()
          resolve()
        } else {
          if (d.code == 10010) {
            isRoleBind = 0
            Role.state_roleUnbind()
            Role.UI_noRole()
          } else {
            setTip(d.messages)
            reject(d.messages)
          }
        }
      })
    })
  },
  api_submitRoleInfo: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.roleBind,
        data: {
          platform: sel_platform.val(),
          roleId: sel_role.val()
        },
        dataType: 'jsonp'
      }).done(d => {
        if (d.success) {
          isRoleBind = 1
          resolve()
          Role.state_roleBinded()
        } else {
          setTip(d.messages)
          reject(d.messages)
        }
      })
    })
  },
  api_getRoleList: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.roleList,
        dataType: 'jsonp'
      }).done(d => {
        if (d.success) {
          roleList = d.data
          if (roleList.length > 0) {
            Role.UI_select(duplicate(roleList, 'platform'), 'platform')
            resolve()
          } else {
            Role.UI_noRole()
          }
        } else {
          $('[data-btn-logout]').trigger('click')
          // setTip(d.messages)
          reject(d.messages)
        }
      })
    })
  },
  api_submitGetlibao: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.submitGetlibao,
        dataType: 'jsonp'
      }).done(d => {
        if (d.success) {
          resolve(true)
          setTip(d.messages)
        } else {
          setTip(d.messages)
          reject(d.messages)
        }
      })
    })
  },
  validate_select: () => {
    if (sel_platform.val() == '0') {
      $('.form-error')
        .text('请选择系统')
        .show()
      return false
    } else if (sel_server.val() == '0') {
      $('.form-error')
        .text('请选择区服')
        .show()
      return false
    } else if (sel_role.val() == '0') {
      $('.form-error')
        .text('请选择角色')
        .show()
      return false
    } else if (
      sel_platform.val() == userInfo.platform &&
      sel_server.val() == userInfo.serverId &&
      sel_role.val() == userInfo.roleId
    ) {
      $('.form-error')
        .text('少侠，您已经绑定当前角色！')
        .show()
      return false
    } else {
      return true
    }
  },
  state_roleBinded: () => {
    Role.UI_roleSet()
  },
  state_roleUnbind: () => {
    $('[data-dialog-role]').show()
  },
  trigger_submitTarget: target => {
    if (!isRoleBind) {
      sceneTarget = target
      Role.state_roleUnbind()
      return
    }
  },
  UI_select: (list, obj) => {
    let id, name
    if (obj == 'platform') {
      id = name = obj
    } else {
      id = obj + 'Id'
      name = obj + 'Name'
    }
    if (list.length > 1) {
      $('#' + obj).html(`<option value="0">请选择</option>`)
      list.forEach(ele => {
        $('#' + obj).append(
          `<option value="${ele[id]}">${optionStr(obj, ele[name])}</option>`
        )
      })
    } else {
      $('#' + obj).html(
        `<option value="${list[0][id]}">${optionStr(
          obj,
          list[0][name]
        )}</option>`
      )
      switch (obj) {
        case 'platform':
          selInit(list[0][id], 'platform', 'server')
          break
        case 'server':
          selInit(list[0][id], 'serverId', 'role')
          break
        // case 'role':
        //   selRoleInit(list[0][id])
        //   break
        default:
          break
      }
    }
  },
  UI_roleSet: () => {
    if (isRoleBind) {
      let platform = ''
      if (/ios/gi.test(userInfo.platform)) {
        platform = 'iOS'
      }
      if (/android/gi.test(userInfo.platform)) {
        platform = 'Android'
      }
      $('[data-role-info]')
        .text(platform + '-' + userInfo.serverName + '-' + userInfo.roleName)
        .show()
      $('[data-btn-bind-dialog]').text('【更换绑定】')

      if (parseInt(userInfo.canGetGift)) {
        $('[data-yylb]').show()
      } else {
        $('[data-yylb]').hide()
      }
    } else {
      $('[data-role-info]')
        .text('')
        .hide()
      $('[data-btn-bind-dialog]').text('【绑定角色】')
      $('[data-yylb]').hide()
    }
    $('[data-has-role]').show()
    $('[data-no-role]').hide()
  },
  UI_noRole: () => {
    isRoleBind = 0
    if (roleList.length > 0) {
      $('[data-has-role]').show()
      $('[data-no-role]').hide()
    } else {
      $('[data-btn-bind-dialog]').text('【绑定角色】')
      $('[data-has-role]').hide()
      $('[data-no-role]').show()
    }
    $('[data-role-info]')
      .text('')
      .hide()
    Scene.UI_sceneReset()
    Friend.UI_friendReset()
    Lottery.UI_lotterySurplus(0)
    return
  }
}

const optionStr = (obj, str) => {
  let name = ''
  if (obj == 'platform' && /ios/gi.test(str)) {
    name = 'iOS'
  } else if (obj == 'platform' && /android/gi.test(str)) {
    name = 'Android'
  } else {
    name = str
  }
  return name
}

const duplicate = (arr, type) => {
  const res = new Map()
  return arr.filter(a => !res.has(a[type]) && res.set(a[type], 1))
}

$('[data-btn-bind-dialog]').click(() => {
  sceneTarget = 0
  if (isRoleBind) {
    if (!userInfo.canChange) {
      $('[data-dialog-role-unchanged]').show()
      return
    }
    sel_platform.val(userInfo.platform)
    sel_platform.trigger('change')
    sel_server.val(userInfo.serverId)
    sel_server.trigger('change')
    sel_role.val(userInfo.roleId)
  }
  $('[data-dialog-role]').show()
  bi('链接-打开绑定角色弹窗')
  fullPage.lockScroll()
})
$('[data-btn-bind]').click(async () => {
  if (!Role.validate_select()) {
    return
  }
  await Role.api_submitRoleInfo()
  setTip('绑定成功')
  $('[data-dialog-role]').fadeOut(() => {
    fullPage.scroll()
  })
  Scene.UI_sceneReset()

  Login.UI_logined()

  if (sceneTarget) {
    sceneTarget.trigger('click')
  }
  bi('按钮-绑定角色')
})

function selInit(val, valObj, obj) {
  const list = valObj == 'platform' ? roleList : tempServerList
  tempServerList = list.filter(ele => {
    return ele[valObj] == val
  })
  Role.UI_select(duplicate(tempServerList, obj + 'Id'), obj)
}
function selRoleInit(val) {
  tempRoleList = tempServerList.filter(ele => {
    return ele.serverId == val
  })
  Role.UI_select(tempRoleList, 'role')
}

sel_platform.on('change', e => {
  $('.form-error').hide()
  sel_server.html('<option value="0">请选择</option>')
  sel_role.html('<option value="0">请选择</option>')
  const val = $(e.target).val()
  if (val == '0') {
    return
  }
  selInit(val, 'platform', 'server')
})
sel_server.on('change', e => {
  $('.form-error').hide()
  selRoleInit($(e.target).val())
})
sel_role.on('change', () => {
  $('.form-error').hide()
})

$('[data-dialog-role] select').blur(() => {
  setTimeout(() => {
    $('body,html').scrollTop(0)
  }, 10)
})

$('[data-btn-yylb-dialog]').click(() => {
  $('[data-dialog-yylb]').show()
  fullPage.lockScroll()
})

$('[data-btn-yylb]').click(async () => {
  if (await Role.api_submitGetlibao()) {
    $('[data-dialog-yylb]').hide()
    $('[data-yylb]').hide()
    fullPage.scroll()
  }
})

export { Role, isRoleBind, userInfo, roleList }
